import moment from 'moment';
import {useEffect, useState} from 'react';
import {useMeetings} from '../../../../data/hooks/meeting/useMeetings';

export function useSlotSelection(eventId, participants, speakers, programItem) {
    const [availableSlots, setAvailableSlots] = useState([]),
        [slot, setSlot] = useState(null),
        [loading, setLoading] = useState(false),
        meetings = useMeetings(eventId);

    // load available slots
    useEffect(() => {
        let pending = true;

        setLoading(true);
        async function updateSlots() {
            try {
                let availableSlots = (await app.api.meetings.checkAvailability(eventId, participants, speakers))
                    //
                    // if a programItem is provided, only show slots related to it
                    .filter(slot => !programItem || slot.program_id == programItem.id)
                    //
                    // only allow slots after now
                    .filter(slot => moment().isSameOrBefore(slot.start_local));

                if (pending) {
                    setLoading(false);
                    setAvailableSlots(availableSlots);
                }
            } catch (err) {
                console.error(err);
            }
        }
        updateSlots();

        return () => (pending = false);
    }, [eventId, participants, speakers, programItem, meetings]);

    // make sure slot still exists
    useEffect(() => {
        if (slot && !availableSlots.find(s => s.id == slot.id)) {
            setSlot(null);
        }
    }, [availableSlots, slot]);

    return [slot, setSlot, availableSlots, loading];
}
